import { inject } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn, UrlTree } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { LocalRepository } from '@shared/helper/local-repository';
import { DRAFT_KEY, DraftModel } from '@shared/helper/draft/models/draft.model';
import { CreateBooklistComponent } from '@app/pages/booklists/pages/create-booklist/create-booklist.component';
import { AlertConfigModel, ConfirmAlertComponent, EConfirmButton } from '@shared/components/confirm-alert/confirm-alert.component';

export const booklistGuard: CanDeactivateFn<CreateBooklistComponent> = (component: CreateBooklistComponent, currentRoute, currentState, nextState):
  Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const dialog: MatDialog = inject(MatDialog);
  const bottomSheet: MatBottomSheet = inject(MatBottomSheet);
  const localRepository: LocalRepository = inject(LocalRepository);

  const dialogInfo: AlertConfigModel = {
    cancelButtonText: 'بله می‌روم',
    confirmButtonText: 'خیر ادامه می‌دهم',
    title: 'می‌خواهید به صفحۀ دیگری بروید؟',
  };

  if (component?.booklistForm?.dirty) {
    const draftableData = {
      books: component.selectedBooks,
      description: component.descriptionField?.value,
      title: component.titleField?.value
    };

    if (localRepository.IsInMobile) {
      const bottomSheetRef = bottomSheet.open(ConfirmAlertComponent, {
        data: dialogInfo,
        panelClass: 'basic-bottomsheet'
      });

      return bottomSheetRef.afterDismissed().pipe(
        map((action: EConfirmButton) => handleAction(action, draftableData, localRepository))
      );
    } else {
      const dialogRef = dialog.open(ConfirmAlertComponent, {
        data: dialogInfo,
        panelClass: 'basic-dialog'
      });

      return dialogRef.afterClosed().pipe(
        map((action: EConfirmButton) => handleAction(action, draftableData, localRepository))
      );
    }
  }

  return of(true);
};

function handleAction(action: EConfirmButton, draftableData: any, localRepository: LocalRepository): boolean {
  if (action === EConfirmButton.CANCLE) {
    const draft: DraftModel = {
      booklist: {
        draftKey: 'booklist',
        books: draftableData.books,
        title: draftableData.title,
        description: draftableData.description,
      }
    };
    let existData: DraftModel = JSON.parse(localRepository.getLocalItem(DRAFT_KEY)!) || new DraftModel();
    if (!existData) {
      existData = new DraftModel();
    }
    existData.booklist = draft.booklist;
    localRepository.setLocalItem(DRAFT_KEY, JSON.stringify(existData));
    return true;
  } else if (action === EConfirmButton.CONFIRM) {
    return false;
  } else {
    return false;
  }
}